import ReactImg from "../assets/react.png";
import NodeImg from "../assets/node.png";
import FirebaseImg from "../assets/firebase.png";
import GithubImg from "../assets/github.png";
import DockerImg from "../assets/docker.png";
import MongoImg from "../assets/mongo.png";
import SpringImg from "../assets/spring.png";
import TypescriptImg from "../assets/typescript.png";
import PostgresImg from "../assets/postgres.png";
// import KotlinImg from "../assets/android_kotlin.png";

export const data = {
  firstname: "Jamal",
  lastname: "SIDIKOU",
  job: "developpeur FullStack Web/mobile",
  littlePresentation: `Diplômé d'un master en architecture logicielle, je suis passionné par le développement web et mobile.`,
  BigPresentation:
    " Je suis constamment en quête de nouvelles opportunités pour mettre en œuvre des solutions techniques innovantes et offrir des expériences utilisateur exceptionnelles.\n Mon approche repose sur une analyse approfondie des besoins, une collaboration étroite avec les équipes et un engagement envers la qualité à chaque étape du processus.\n\n Merci de votre visite et à bientôt !",
  skills: [
    {
      id: 1,
      name: "React/React-native",
      img: ReactImg,
    },
    {
      id: 2,
      name: "NodeJs",
      img: NodeImg,
    },
    {
      id: 3,
      name: "Typescript",
      img: TypescriptImg,
    },
    {
      id: 4,
      name: "MongoDb",
      img: MongoImg,
    },
    {
      id: 5,
      name: "Firebase",
      img: FirebaseImg,
    },
    {
      id: 6,
      name: "Spring",
      img: SpringImg,
    },
    {
      id: 7,
      name: "Docker",
      img: DockerImg,
    },
    {
      id: 8,
      name: "Postgres",
      img: PostgresImg,
    },
    {
      id: 9,
      name: "Github",
      img: GithubImg,
    },
    // {
    //     id: 10,
    //     name: "Android/Kotlin",
    //     img: KotlinImg
    // },
  ],
  work: [
    {
      title: "plateforme de coding",
      // img:,
      code: "https://github.com/SJamal08/code-platform",
      demo: "",
    },
  ],
};
